module.exports = __webpack_public_path__ + "static/media/csm-pin.e5d95108.svg";